/**
 * paperNum 与 paperSpace必须同时指定
 * 且paperNum 与 paperSpace个数须匹配
 * @param {*} paperWidth
 * @param {*} paperNum
 * @param {*} paperSpace
 * @param {*} speedWave
 * @param {*} skewWave
 * @param {*} shapeWave
 * @param {*} width
 * @param {*} height
 * @param {*} speed
 * @param {*} duration
 */
export default function (
  paperWidth = 10, // 纸片宽度
  paperNum = 7, // 纸片数量
  paperSpace = [0, 0.1, 0.15, 0.3, 0.15, 0.1, 0.2], // 纸片间距
  speedWave = 2, // 下落速度波动范围
  skewWave = 3, // 横向速度波动范围
  shapeWave = 3, // 多边形定点波动范围
  width = 340, // 宽度
  height = 200, // 高度
  speed = 0.4, // 播放速度
  duration = 4 // 持续时间
) {
  let position = paperSpace.map(item => (width - paperNum * paperWidth) * item)
  let i = 0
  let papers = []
  let stop = false

  function round (value) {
    return Math.floor(value)
  }

  function seed () {
    return Math.random()
  }

  function initVars (n) {
    for (let i = 0; i < n; i++) {
      let paper = {
        r: round(seed() * 255),
        g: round(seed() * 255),
        b: round(seed() * 255),
        x: round(seed() * 10 + position[i]),
        y: round(seed() * 20 - 10),
        speed: round(seed() * speedWave + 1), // 下落速度
        skew: seed() * 2 * skewWave - skewWave, // 偏移速度
        rect: [
          0, 0,
          10 + seed() * 2 * shapeWave - shapeWave, 0 + seed() * 2 * shapeWave - shapeWave,
          10 + seed() * 2 * shapeWave - shapeWave, 10 + seed() * 2 * shapeWave - shapeWave,
          0 + seed() * 2 * shapeWave - shapeWave, 10 + seed() * 2 * shapeWave - shapeWave,
        ],
      }
      papers.push(paper)
    }
  }

  function draw () {
    let canvas = document.querySelector('#canvas')
    let ctx = canvas.getContext('2d')
    ctx.clearRect(0, 0, width, height)
    i++
    if (i >= 60 * duration) {
      i = 0
      ctx.clearRect(0, 0, width, height)
      stop = true
      return
    }
    ctx.save()
    ctx.translate(0, i * speed)
    for (let cnt = 0; cnt < papers.length; cnt++) {
      let { r, g, b, x, y, skew, speed: selfSpeed, rect } = papers[cnt]
      ctx.fillStyle = `rgb(${r},${g},${b}`
      ctx.translate(x + skew * i * speed / 2, y + selfSpeed * speed * i)
      ctx.beginPath()
      ctx.moveTo(rect[0], rect[1])
      ctx.lineTo(rect[2], rect[3])
      ctx.lineTo(rect[4], rect[5])
      ctx.lineTo(rect[6], rect[7])
      ctx.fill()
      ctx.translate(-skew * i * speed / 2, -selfSpeed * speed * i)
    }
    ctx.restore()
  }

  function frame () {
    // console.log(stop)
    if (!stop) {
      draw()
      requestAnimationFrame(frame)
    }
  }
  initVars(paperNum)
  frame()
}
